import React from 'react';
import PropTypes from 'prop-types';
import { Container, Row } from 'reactstrap';
import HeaderContainerTemplate from '../containers/templates/HeaderContainerTemplate';
import AttendeesListContainer from '../containers/AttendeesListContainer';

import './styles/AttendeesListScreen.scss';

class AttendeesList extends React.Component {
  render() {
    return (
      <HeaderContainerTemplate>
        <Container className="content-wrapper">
          <Row>
            <AttendeesListContainer
              accessToken={ this.props.match.params.accessToken }
            />
          </Row>
        </Container>
      </HeaderContainerTemplate>
    );
  }
}

AttendeesList.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      accessToken: PropTypes.string
    })
  }).isRequired
};

export default AttendeesList;



// WEBPACK FOOTER //
// ./src/scenes/AttendeesList.js